import React from 'react';
import { wellnessFaqArray } from '../../utils/data/WellnessFaqData';

function WellnessFaqSection() {
  return (
    <section className='grid gap-y-8 px-8 py-12 xl:py-24 2xl:px-32 lg:px-16'>
      {/* Heading */}
      <div className='grid gap-y-4 justify-center'>
        <h3 className='font-titleFont text-2xl text-center border-b-2 border-solid border-colour2 dark:border-colour3 pb-2'>
          WELLNESS COACHING FAQ
        </h3>
        <h4 className='text-center lg:text-xl italic font-serif'>
          Common questions answered
        </h4>
      </div>

      {/* FAQ Grid */}
      <div className='grid gap-6 lg:grid-cols-2'>
        {wellnessFaqArray.map((faq, index) => (
          <article
            key={index}
            className='grid gap-3 bg-colour1 dark:text-colour2 rounded-3xl shadow-md p-6'
          >
            <h5 className='text-lg font-semibold font-titleFont'>
              {faq.question}
            </h5>
            <p className='text-sm opacity-90'>{faq.answer}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default WellnessFaqSection;
